// 운영 임계값 — GUIDE.md §2 "정상·이상 기준"과 단일 소스로 맞춘다.
// 프로모(실효 마진 ~50%) 오탐을 피하려 보수적으로 잡는다. 운영하며 조정.
//
// 반환: "ok" | "warn" | "bad"

// 마진%: 손실(<0)만 명확한 이상, 0~30%는 주의, 그 외 정상.
// null/빈값(데이터 없음)은 ok 로 둬 오표시를 막는다.
export function marginStatus(marginPct) {
  if (marginPct == null || marginPct === "") return "ok";
  const m = Number(marginPct);
  if (!Number.isFinite(m)) return "ok";
  if (m < 0) return "bad";
  if (m < 0.3) return "warn";
  return "ok";
}

// 잔액: 최소 잔액 100 NC 미만이면 사용 차단 임박(이상), 200 미만 주의.
// null/빈값은 ok.
export function balanceStatus(balance) {
  if (balance == null || balance === "") return "ok";
  const b = Number(balance);
  if (!Number.isFinite(b)) return "ok";
  if (b < 100) return "bad";
  if (b < 200) return "warn";
  return "ok";
}

export const STATUS_TEXT_CLASS = {
  ok: "text-emerald-700",
  warn: "text-amber-700",
  bad: "text-red-600",
};

// 마진% 강조색 — 국내 증시 표기 관례(상승=빨강/하락=파랑)에 맞춰 양수(+)는 빨강,
// 음수(-)는 파랑. 기간별 추세 테이블 등 마진%를 강조 표시하는 모든 곳에서 공용으로 쓴다.
export function marginColorClass(pct) {
  const p = Number(pct);
  if (!Number.isFinite(p) || p === 0) return "text-ink-500";
  return p > 0 ? "text-red-600" : "text-blue-600";
}

// 고액 보유(운영자가 우선 확인할 만한 잔액) — 10만 NC 이상.
export const HIGH_BALANCE_THRESHOLD = 100_000;
export function isHighBalance(balance) {
  return Number(balance) >= HIGH_BALANCE_THRESHOLD;
}

// 내부/데모 계정 판별 — 잔액 100만 NC 이상은 실결제로 도달 불가능한 금액(최대 충전
// 5만원×프로모 2배)이라 관리자가 수동 지급한 내부/데모 계정으로 본다. 리텐션 탭의
// 이탈 위험 리스트처럼 "진짜 고객" 분석에서 이런 계정을 제외할 때 사용(2026-07-18,
// 1억 NC 데모 계정이 "제품 관심 필요"로 뜨던 노이즈 제거).
export const INTERNAL_BALANCE_THRESHOLD = 1_000_000;
export function isInternalAccount(balance) {
  return Number(balance) >= INTERNAL_BALANCE_THRESHOLD;
}

// 미사용 일수 — lastSeen(ISO) 기준. 없으면 null(판단 불가).
export function daysSince(iso) {
  if (!iso) return null;
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return null;
  return Math.floor((Date.now() - t) / 86400000);
}
export const INACTIVE_DAYS_THRESHOLD = 14;
